export const ApolloClientSingleton = /*#__PURE__*/ Symbol.for(
  "ApolloClientSingleton"
);
